/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/showtimes/calendarUI.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/showtimes/calendarUI', exports: {} };
const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from '@take-2/fd-modules/splits/require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_util as Fandango_util_formatDate } from '@take-2/fd-modules/splits/require-global';

const { formatDate } = Fandango_util_formatDate;


import { global_consts as global_consts_QueryParams } from '@take-2/fd-modules/splits/require-core';

const { QueryParams } = global_consts_QueryParams;


import { Fandango_dateUtil as dateUtil } from '@take-2/fd-modules/splits/require-global';



import { Fandango_carousel as fdCarousel } from '@take-2/fd-modules/splits/require-global';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import hearts from '@take-2/fd-modules/shared/utils/hearts';



import historyStates from '@take-2/fd-modules/movie/shared/historyStates';



import movieShowtimeGroupings from '@take-2/fd-modules/theater/showtimes/movieShowtimeGroupings';



import openChainFilter from '@take-2/fd-modules/theater/showtimes/openChainFilterDesktop';



const ShortWeekdayNames = ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat']


const LongWeekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']


const ShortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']


const LongMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']


const DEFAULT_NUM_DATES = 60


const MIN_NUM_DATES = 7


const DataAttribs = Object.freeze({
    DATE: 'data-show-time-date',
    DISABLED: 'data-disabled'
})


const Selectors = {
    CALENDAR_WRAP: '#lazyload-movie-date-picker',
    DATE_ITEM: `[${DataAttribs.DATE}]:not([${DataAttribs.DISABLED}="true"])`,
    DATE_CAROUSEL: 'date-carousel',
}


const Classes = {
    DATE_BTN: 'date-picker__button',
    IS_SELECTED: 'fd-carousel--last-selected',
}


const RegExes = {
    DASH: /-/g,
}


const zeroPad = value => `${value < 10 ? '0' : ''}${value}`
function getNextDay(priorDay) {
    priorDay = new Date(priorDay.full.replace(RegExes.DASH, '/'));
    return new Date(priorDay.setDate(priorDay.getDate() + 1));
}
function getDate() {
    const param = dateUtil.dateFromQuery(QueryParams.DATE, window.location.search, { iso: true });
    return formatDate(param ? new Date(param) : new Date());
}
function getDates() {
    const dates = [];
    const selectedDate = getDate();
    for (let i = 0; i < DEFAULT_NUM_DATES; i++) {
        const nextDate = dates.length ? getNextDay(dates[dates.length - 1]) : new Date();
        const dayShort = nextDate.getDate();
        const day = zeroPad(dayShort);
        const year = nextDate.getFullYear();
        const monthNum = nextDate.getMonth();
        const month = zeroPad(monthNum + 1);
        const full = `${year}-${month}-${day}`;
        const isSelected = Boolean(full === selectedDate);
        const isToday = Boolean(full === formatDate(new Date().toDateString()));
        dates.push({
            day,
            dayShort,
            dayNameLong: isToday ? 'Today' : LongWeekdayNames[nextDate.getDay()],
            dayNameShort: isToday ? 'Today' : ShortWeekdayNames[nextDate.getDay()],
            full,
            isInitiallySelected: isSelected,
            isToday,
            month,
            monthNameLong: LongMonthNames[monthNum],
            monthNameShort: ShortMonthNames[monthNum],
            year,
        });
    }
    return dates;
}
function onDateClick(e) {
    e.preventDefault();
    const selectedDate = `${this.dataset.showTimeDate}`.trim();
    if (!selectedDate || this.querySelector(`.${Classes.DATE_BTN}`).classList.contains(Classes.IS_SELECTED)) {
        return;
    }
    historyStates.push(historyStates.HistoryEventTypes.CALENDAR, selectedDate);
    movieShowtimeGroupings.init();
    hearts.init();
    openChainFilter.init();
    track({
        event: EventTypes.DATE_SELECTED,
        dateSelected: `${selectedDate} 00:00:00`,
    });
}
function renderCalendar() {
    const dates = getDates();
    const markup = swig.render('_theaterCalendar', { dates });
    const container = document.querySelector(Selectors.CALENDAR_WRAP);
    container.innerHTML = markup;
    fdCarousel.init(Selectors.DATE_CAROUSEL, {
        fixedWidth: '62px',
        fixedHeight: '70px',
        gap: 8,
        padding: { left: 0, right: 0 },
        perPage: MIN_NUM_DATES,
        setSelected: true,
        start: dates.findIndex(date => date.isInitiallySelected),
        goToIndexOnClick: true,
    });
    container
        .querySelectorAll(Selectors.DATE_ITEM)
        .forEach(date => date.addEventListener('click', onDateClick));
}
export default {
    renderCalendar,
};
